import { z } from "zod/v4"

export const SubscriptionKindNormal = z.literal("normal")
export const SubscriptionKindPremium = z.literal("premium")
export const SubscriptionKindPremiumPlus = z.literal("premium-plus")
